export default __webpack_public_path__ + "static/B0262-d23d0d98b0e30b945af39af38fafca63.png";